import createStyle from './createStyle';
export const buildGet = typography => {
  const get = function (type) {
    let withColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let withLineHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (withColor && withLineHeight) {
      console.warn(`Use typography.types['${type}'] instead of get method`);
    }
    if (!withColor && !withLineHeight) {
      console.warn(`Use typography.defaults['${type}'] instead of get method`);
    }
    return createStyle(typography[type], withColor, withLineHeight);
  };
  return get;
};
//# sourceMappingURL=get.js.map